<!-- 上传Pdf组件 -->
<template>
	<div>
		<!-- <el-upload :on-success="handleAvatarSuccess" :before-upload="beforeUpload" :action="action"
			list-type="picture-card" :on-preview="handlePictureCardPreview" :file-list="imgs" :multiple="true"
			:limit="img_num" :on-change="handleLimit" :class="{disabled:uploadDisabled}" :on-remove="handleRemove"
			:data="data">
			<i class="el-icon-plus"></i>
		</el-upload>
		<el-dialog :visible.sync="dialogVisible" append-to-body>
			<img width="100%" :src="dialogImageUrl" alt="">
		</el-dialog> -->


		<el-upload class="upload-demo" :on-success="handleAvatarSuccess" :before-upload="beforeUpload" :action="action"
			:on-preview="handlePictureCardPreview" :on-remove="handleRemove" :multiple="true" :limit="img_num"
			:on-change="handleLimit" :file-list="imgs" :data="data">
			<el-button size="small" type="primary">点击上传</el-button>
			<div slot="tip" class="el-upload__tip">只能上传pdf文件 <span v-if="img_num > 1"
					style="color: red;">最多上传{{img_num}}个</span></div>
		</el-upload>
	</div>


</template>

<script>
	import {
		parseTime,getBaseUrl
	} from '@/tool/index'
	import {
		getToken,
	} from '@/tool/cookie'
	import Qs from 'qs'
	export default {
		data() {
			return {
				action: getBaseUrl() + 'SignShop/uploadPdf',
				dialogImageUrl: '', // 图片上传
				dialogVisible: false, // 图片上传
				imgs: [], // 存储的图片数据
				uploadDisabled: false, // 图片上传图标是否显示
				data: {
					'login_uid': '',
					'token': '',
				},
			};
		},
		filters: {
			parseTime,
		},
		props: { // 定义组件的属性
			img_num: { // 限制上传的图片数量
				type: Number,
				default: 1,
			},
			index: { // 父组件的索引
				type: Number,
				default: 0,
			},
			img_edit: { // 定义默认的图片列表
				type: Array | String,
				default: [],
			},
		},
		created() {
			this.data.login_uid = getToken('login_uid');
			this.data.token = getToken('token');
			this.resetImg()
		},
		watch: {
			img_edit() { // 监听img_edit的变化
				this.resetImg()
			}
		},
		methods: {
			resetImg() {
				this.imgs = this.img_edit;
				if (this.imgs == '') {
					this.imgs = [];
				}
				this.imgNumCheck(this.img_edit.length)
			},
			beforeUpload(file) { // 上传之前的操作
				if (file.type != 'application/pdf') {
					this.$message.error('只能上传pdf文件');
					return false;
				}
				const isLt2M = file.size / 1024 / 1024 < 2;
				if (!isLt2M) {
					this.$message.error('上传文件大小不能超过 2MB!');
					return false;
				}
				return true;
			},
			handlePictureCardPreview(file) { // 点击文件列表中已上传的文件时的钩子
				this.dialogImageUrl = file.url;
				this.dialogVisible = true;
			},
			handleAvatarSuccess(res, file, file_list) { // 上传成功的操作
				file.url = file.response.key;
				if (this.img_num > 1) {
					this.$emit("imgList", file, 'add', this.index);
				} else {
					this.$emit("imgList", file_list, this.index);
				}
			},
			handleRemove(file, fileList) { // 图片删除后的操作
				this.imgs = fileList;
				this.imgNumCheck(fileList.length)
				if (this.img_num > 1) {
					this.$emit("imgList", file, 'del', this.index);
				} else {
					this.$emit("imgList", fileList, this.index);
				}
			},
			handleLimit(file, fileList) { //限制图片张数，文件状态改变时的钩子，添加文件、上传成功和上传失败时都会被调用
				this.imgNumCheck(fileList.length)
			},
			imgNumCheck(length) { // 判断图片的张数，用来显示和隐藏
				if (length >= this.img_num) {
					this.uploadDisabled = true;
				} else {
					this.uploadDisabled = false;
				}
			}
		}
	}
</script>

<style>
	/* .el-upload--picture-card 控制图片上传加号部分 */
	.disabled .el-upload--picture-card {
		display: none !important;
	}
</style>
